<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @open-detail="openDetail"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @uploadFile="uploadFileVisible = true"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <UploadFile
      :title="$l('dialog_title_uploadFile') || '上传文件'"
      :visible.sync="uploadFileVisible"
      :fileType="fileType"
      @reload="reload"
    />

    <Detail
      :visible.sync="detailOpts.visible"
      :toolUploadFileCode="detailOpts.toolUploadFileCode"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import UploadFile from '@/views/ecom/ecomTool/components/upload-file'
import Detail from '../detail'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, UploadFile, Detail },
  data() {
    return {
      usePage: true,
      fileType: 'AMZ-CTN-PDF-MERGE',
      uploadFileVisible: false,
      detailOpts: { visible: false, toolUploadFileCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomToolUploadFilesListApi({
          fileType: this.fileType,
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetail({ toolUploadFileCode }) {
      this.detailOpts = { visible: true, toolUploadFileCode }
    },
  },
}
</script>
